import type {
    CSSProperties,
    ElementType,
    FC,
    HTMLAttributes,
    ReactNode
} from 'react'

import { useInView } from '@/hooks/use-in-view'

interface RevealProps extends HTMLAttributes<HTMLElement> {
    as?: ElementType
    children: ReactNode
    /** Extra delay in milliseconds before the element starts moving. */
    delay?: number
    /** Position inside a staggered group; each step adds 90ms. */
    index?: number
    variant?: 'up' | 'fade' | 'scale'
}

const Reveal: FC<RevealProps> = ({
    as: Tag = 'div',
    children,
    delay = 0,
    index = 0,
    variant = 'up',
    style,
    ...rest
}): ReactNode => {
    const ref = useInView<HTMLElement>()

    const revealStyle = {
        ...style,
        '--reveal-delay': `${delay}ms`,
        '--i': index
    } as CSSProperties

    return (
        <Tag
            ref={ref}
            data-reveal={variant === 'up' ? '' : variant}
            style={revealStyle}
            {...rest}
        >
            {children}
        </Tag>
    )
}

export default Reveal
